import { useCallback, useState } from 'preact/hooks';
import { useOnImageLoad } from './useOnImageLoad';

export function useImageRatio(target: HTMLImageElement | null) {
  const [imgRatio, setImgRatio] = useState(0);
  const onLoad = useCallback(() => {
    if (!target) return;

    const newImgRatio = target.naturalWidth / target.naturalHeight;
    if (newImgRatio != imgRatio && !isNaN(newImgRatio)) {
      setImgRatio(newImgRatio);
    }
  }, [target]);

  useOnImageLoad(target, onLoad);

  return imgRatio;
}
